module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-23.a7537cb0.png";